import Box from '@material-ui/core/Box';
import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { useLocation, useHistory } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import './index.css';
import Billing from './billing';
import ImportHistory from './crm/import';
import ProfileTab from './account/profile';
import WorkspaceTab from './account/workspace';
import PropertyManagement from './crm/properties';
import TitleRoute from '../../components/titleRoute.js';
import NotificationSettings from './notifications';

const Settings = () => {
  const history = useHistory();
  const location = useLocation();
  const tabs = [
    { label: 'Profile', id: 'profile' },
    { label: 'Workspace', id: 'workspace' },
    { label: 'Notifications', id: 'notifications' },
    { label: 'Properties', id: 'crm-properties' },
    { label: 'Imports & Exports', id: 'import-export' },
    {
      label: 'Billing',
      id: 'billing',
      hasSubOptions: true,
      subOptions: [
        { label: 'Active Plan', id: 'billing-active-plan' },
        { label: 'Credits', id: 'billing-credits' },
        { label: 'Usage', id: 'billing-usage' },
      ]
    },
    // { label: 'Agency', id: 'agency' },
  ]
  const [tabId, setTabId] = useState('profile');
  const [expandedMenus, setExpandedMenus] = useState({});

  useEffect(() => {
    const params = new URLSearchParams(location['search']);
    const tabParam = params.get('tab');
    if (tabParam) {
      // Check if it's a main tab
      const mainTab = tabs.find(tab => tab['id'] === tabParam);
      if (mainTab) {
        setTabId(tabParam);
        return;
      }
      // Check if it's a sub-option
      for (const tab of tabs) {
        if (tab.subOptions) {
          const subOption = tab.subOptions.find(sub => sub.id === tabParam);
          if (subOption) {
            setTabId(tabParam);
            setExpandedMenus(prev => ({ ...prev, [tab.id]: true }));
            return;
          }
        }
      }
    }
  }, [location['search']])

  const handleTabClick = (tab) => {
    if (tab.hasSubOptions) {
      // Toggle expand/collapse for menu with sub-options
      setExpandedMenus(prev => ({ ...prev, [tab.id]: !prev[tab.id] }));
      // If expanding and no sub-option is selected, select the first sub-option
      if (!expandedMenus[tab.id]) {
        const isSubOptionSelected = tab.subOptions.some(sub => sub.id === tabId);
        if (!isSubOptionSelected) {
          const firstSubOption = tab.subOptions[0];
          setTabId(firstSubOption.id);
          history.push(`?tab=${firstSubOption.id}`);
        }
      }
    } else {
      setTabId(tab.id);
      history.push(`?tab=${tab.id}`);
    }
  };

  const handleSubOptionClick = (subOption) => {
    setTabId(subOption.id);
    history.push(`?tab=${subOption.id}`);
  };

  const isTabActive = (tab) => {
    if (tab.id === tabId) return true;
    if (tab.subOptions) {
      return tab.subOptions.some(sub => sub.id === tabId);
    }
    return false;
  };

  const tabOptionsPhone = () => (
    <div className='tabs-box'>
      <div className='tabs-email tabs-setting-main'>
        <div className='settings-sidebar-menu'>
          {tabs.map(tab => (
            <div key={tab.id} className='settings-menu-item-wrapper'>
              <div
                className={`settings-menu-item ${isTabActive(tab) ? 'active' : ''}`}
                onClick={() => handleTabClick(tab)}
              >
                <span className='menu-label'>{tab.label}</span>
                {tab.hasSubOptions && (
                  <span className='menu-expand-icon'>
                    {expandedMenus[tab.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </span>
                )}
              </div>
              {tab.hasSubOptions && expandedMenus[tab.id] && (
                <div className='settings-sub-menu'>
                  {tab.subOptions.map(subOption => (
                    <div
                      key={subOption.id}
                      className={`settings-sub-menu-item ${tabId === subOption.id ? 'active' : ''}`}
                      onClick={() => handleSubOptionClick(subOption)}
                    >
                      {subOption.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )

  return (
    <div className='content'>
      <div className='main-container setting-container'>
        <div className='page-title-area setting-page'>
          <TitleRoute />
        </div>
        <div className='bottom-content-area setting-bottom-content'>
          <div className='content account-tabs'>
            <div className='account-tab-inner'>
              <div className='left-area'>
                <div className='tab-inner-page'>
                  {tabOptionsPhone && tabOptionsPhone()}
                </div>
              </div>
              <div className='right-tabs-area billing-tabs'>
                <div className='tabs-content'>
                  <TabPanel value={tabId} index='profile'> <ProfileTab tabOptionsPhone={tabOptionsPhone} /> </TabPanel>
                  <TabPanel value={tabId} index='workspace'> <WorkspaceTab tabOptionsPhone={tabOptionsPhone} /> </TabPanel>
                  <TabPanel value={tabId} index='billing-active-plan'> <Billing defaultTab={0} /></TabPanel>
                  <TabPanel value={tabId} index='billing-credits'> <Billing defaultTab={1} /></TabPanel>
                  <TabPanel value={tabId} index='billing-usage'> <Billing defaultTab={2} /></TabPanel>
                  <TabPanel value={tabId} index='notifications'> <NotificationSettings /></TabPanel>
                  <TabPanel value={tabId} index='crm-properties'> <PropertyManagement tabOptions={tabOptionsPhone} /></TabPanel>
                  <TabPanel value={tabId} index='import-export'> <ImportHistory tabOptions={tabOptionsPhone} /></TabPanel>
                  {/* <TabPanel value={tabId} index='agency'> <AgencyTab tabOptionsPhone={tabOptionsPhone} /> </TabPanel> */}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box p={3}> <Typography>{children}</Typography> </Box>}
    </div>
  )
}

export default Settings;